import { includes } from 'lodash';
import organization from '../Components/Forms/Organization/index.jsx';
import { RFID_TAG_STATUS } from '../Constants.js';

export const userRoleFilter = {
  fields: {
    name: true
  }
};

export const usersFilter = {
  where: {
    or: []
  },
  include: [
    {
      relation: 'userOrganizationRoles',
      scope: {
        include: [
          {
            relation: 'role',
            scope: {
              // fields: {
              //   id: true,
              //   name: true
              // }
            }
          },
          {
            relation: 'organization',
            scope: {
              include: [
                {
                  relation: 'organizationType'
                }
              ]
            }
          }
        ]
      }
    },
    {
      relation: 'rfidTags',
      scope: {
        where: {
          status: RFID_TAG_STATUS.ACTIVE
        }
      }
    },
    {
      relation: 'parentOrganization'
    }
  ]
};
export const orgUsersFilter = (search) => {
  return {
    include: [
      {
        relation: 'userOrganizationRoles',
        scope: {
          include: [
            {
              relation: 'user',
              scope: usersFilter
            }
          ]
        }
      }
    ]
  };
};
export const chargerReportsFilter = (from, to) => {
  return {
    include: [
      {
        relation: 'sessions',
        scope: {
          where: {
            createdAt: { between: [from, to] }
          },
          include: [
            {
              relation: 'paymentIntent'
            }
          ]
        }
      },
      {
        relation: 'chargePointStatusNotifications'
      },
      {
        relation: 'prices'
      },
      {
        relation: 'chargePointConfiguration'
      },
      {
        relation: 'organization'
      },
      {
        relation: 'chargePointConnectors'
      }
    ]
  };
};
// export const usersFilter = {
//   offset: 0,
//   limit: 100,
//   skip: 0,
//   fields: {
//     id: true,
//     email: true,
//     firstName: true,
//     lastName: true,
//     userName: true,
//     active: true
//   },
//   include: [
//     {
//       relation: 'roles',
//       scope: { fields: { name: true, id: true } }
//     },
//     {
//       relation: 'organizations',
//       scope: {
//         fields: { name: true, id: true, active: true, organizationTypeId: true },
//         include: [
//           {
//             relation: 'roles',
//             scope: {
//               fields: { name: true, id: true, userId: true },
//               where: {
//                 trash: false
//               }
//             }
//           },
//           {
//             relation: 'organizationType',
//             scope: { fields: { name: true, id: true } }
//           }
//         ]
//       }
//     },
//     {
//       relation: 'rfidTags'
//     }
//   ]
// };
export const chargersFilter = (active) => {
  return {
    offset: 0,
    limit: 100,
    skip: 0,
    where: {
      ...(active && { active: active }),
      deletedAt: null
    },

    include: [
      {
        relation: 'prices',
        scope: { fields: {} }
      },
      {
        relation: 'chargePointConfiguration',
        scope: { fields: {} }
      },
      {
        relation: 'organization',
        scope: { fields: {} }
      },
      {
        relation: 'chargePointConnectors',
        scope: { fields: {} }
      },
      {
        relation: 'chargePointStatusNotifications',
        scope: { fields: {} }
      },
      {
        relation: 'geoLocationPoint',
        scope: { fields: {} }
      }
      // {
      //   relation: 'sessions',
      //   scope: { fields: {} }
      // }
    ]
  };
};

export const organizationQueryFilter = (organizationType) => {
  return {
    where: {
      name: organizationType,
      active: true
    },
    include: [
      {
        relation: 'organizations',
        scope: {
          include: [
            {
              relation: 'chargePoints',
              scope: {
                include: [{ relation: 'chargePointConnectors' }],
                fields: {
                  id: true,
                  organizationId: true,
                  name: true
                }
              }
            },
            {
              relation: 'organizationProperties'
            }
          ]
        }
      }
    ]
  };
};

export const activeOrganizations = {
  where: {
    name: 'BASE'
  },
  include: [
    {
      relation: 'organizations',
      scope: {
        where: {
          active: true
        },
        include: [
          {
            relation: 'chargePoints',
            scope: {
              include: [{ relation: 'chargePointConnectors' }],
              fields: {
                id: true,
                organizationId: true,
                name: true
              }
            }
          },
          {
            relation: 'organizationProperties'
          },
          {
            relation: 'organizationParentOrganization',
            scope: {
              // fields: {
              //   id: true,
              //   parentOrganizationId: true
              // },
              include: [
                {
                  relation: 'parentOrganization',
                  scope: {
                    fields: {
                      name: true
                    }
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};

export const activeProvidersFilter = {
  where: {
    name: 'PROVIDER'
  },
  include: [
    {
      relation: 'organizations',
      scope: {
        where: {
          active: true
        },
        include: [
          {
            relation: 'chargePoints',
            scope: {
              include: [{ relation: 'chargePointConnectors' }],
              fields: {
                id: true,
                organizationId: true,
                name: true
              }
            }
          },
          {
            relation: 'organizationProperties'
          }
        ]
      }
    }
  ]
};

export const chargePointsAndConnectorsFilter = {
  fields: {
    organizationId: true,
    slug: true,
    name: true,
    status: true,
    public: true,
    id: true
  },
  include: [
    {
      relation: 'chargePointConfiguration',
      scope: {
        fields: {
          currency: true,
          powerType: true,
          wattsAuthorize: true,
          maxPower: true
          // "price":true
        }
      }
    },

    {
      relation: 'organization',
      scope: {
        include: [
          { relation: 'organizationProperties' },
          {
            relation: 'organizationParentOrganization'
            // scope: { include: [{ relation: 'parentOrganizations' }] }
          }
        ]
      }
    },

    {
      relation: 'chargePointConnectors',
      scope: {
        fields: {
          id: true,
          chargePointId: true,
          remoteId: true,
          status: true
        },
        include: [
          {
            relation: 'sessions',
            scope: {
              where: {
                endDate: null // Include only sessions where endDate is null
              }
              // Energy values are now on session: totalEnergyConsumed, powerActiveImportValue
            }
          }
        ]
      }
    },
    {
      relation: 'prices'
    }
  ]
};

export const providerFilter = {
  where: {
    organizationTypeId: 2
  }
};

export const chargePointStatusNotificationQueryFilter = (start, end) => ({
  where: {
    createdAt: {
      between: [start.toISOString(), end.toISOString()]
    }
  }
});

export const organizationDetailFilter = {
  include: [
    {
      relation: 'organizationProperties'
    },
    {
      relation: 'chargePoints'
    },
    {
      relation: 'chargePoints'
    },
    {
      relation: 'organizationParentOrganization'
    },
    {
      relation: 'organizationType',
      scope: {
        fields: {
          id: true,
          name: true
        }
      }
    }
  ]
};
export const sessionsFilter = (start, end) => {
  return {
    where: {
      and: [{ createdAt: { gte: start } }, { endDate: { lte: end } }]
    },
    include: [
      {
        relation: 'user',
        scope: {
          fields: {
            email: true,
            userName: true
          },
          include: [
            {
              relation: 'roles',
              scope: {
                fields: {
                  name: true
                }
              }
            },
            {
              relation: 'parentOrganization',
              scope: {
                fields: {
                  name: true
                }
              }
            }
          ]
        }
      },
      {
        relation: 'rfidTag',
        scope: {
          fields: {
            value: true
          }
        }
      },
      {
        relation: 'paymentIntent',
        scope: {
          fields: {
            amount: true
          }
        }
      }
      // Energy values are now on session: totalEnergyConsumed, powerActiveImportValue, totalTimeElapsed
    ]
  };
};

export const sessionsRangeFilter = (from, to) => {
  return {
    include: [
      {
        relation: 'sessions',
        scope: {
          where: {
            createdAt: { between: [from, to] }
          },
          include: [
            {
              relation: 'paymentIntent'
            }
          ]
        }
      },
      {
        relation: 'chargePointStatusNotifications'
      },
      {
        relation: 'prices'
      },
      {
        relation: 'chargePointConfiguration'
      },
      {
        relation: 'organization'
      },
      {
        relation: 'chargePointConnectors'
      }
    ]
  };
};
export const chargerMeters = {
  include: [
    {
      relation: 'session'
      // Energy values are now on session: totalEnergyConsumed, powerActiveImportValue, totalTimeElapsed
    }
  ]
};

export const userRolesOnOrganizationFilter = {
  include: [
    {
      relation: 'role',
      scope: { fields: { id: true, name: true } }
    }
  ]
};

export const organizationReportsFilter = (from, to) => {
  return {
    include: [
      {
        relation: 'chargePoints',
        scope: {
          include: [
            {
              relation: 'sessions',
              scope: {
                where: {
                  createdAt: { between: [from, to] }
                },
                include: [{ relation: 'paymentIntent' }]
              }
            },
            {
              relation: 'prices'
            },
            {
              relation: 'chargePointConfiguration'
            },
            {
              relation: 'chargePointConnectors'
            }
          ]
        }
      }
    ]
  };
};
